import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const PublicRoute = ({ children }) => {
  const { currentUser, authLoading } = useApp();

  if (authLoading) return null;
  if (currentUser) return <Navigate to="/" replace />;

  return children;
};

export default PublicRoute;
